import React from 'react';
import Slider from 'react-slick';
import { Card, CardContent } from './ui/card';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const WhyYouNeedSlider = ({ reasons }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    adaptiveHeight: true,
  };

  return (
    <div className="why-you-need-slider">
      <Slider {...settings}>
        {reasons.map((reason, index) => (
          <div key={index} className="px-2">
            <Card className="border-2 border-gray-200 hover:border-[#E5B80B] transition-all duration-300 h-full">
              <CardContent className="p-6">
                {reason.image && (
                  <div className="relative h-48 mb-4 rounded-lg overflow-hidden">
                    <img
                      src={reason.image}
                      alt={reason.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}
                {reason.icon && (
                  <div className="flex justify-center mb-4">
                    <div className="p-4 bg-[#E5B80B]/10 rounded-full">
                      <reason.icon className="h-10 w-10 text-[#E5B80B]" />
                    </div>
                  </div>
                )}
                <h3 className="text-xl font-bold text-[#1E1E1E] mb-3 text-center">
                  {reason.title}
                </h3>
                <p className="text-gray-600 text-center leading-relaxed">
                  {reason.description}
                </p>
              </CardContent>
            </Card>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default WhyYouNeedSlider;
